import router from "./routers";
export function toFileManage() {
  router.push({
    name: "FileOperationManage"
  });
}